import { ScholarshipSessionDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScholarshipSessionService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getScholarshipSession(): Observable<ScholarshipSessionDto[]> {
    return this.http.get<ScholarshipSessionDto[]>(
      this.url + 'scholarship-session'
    );
  }

  createScholarshipSession(
    data: ScholarshipSessionDto[]
  ): Observable<ScholarshipSessionDto[]> {
    return this.http.post<ScholarshipSessionDto[]>(
      this.url + 'scholarship-session',
      data
    );
  }
  getSingleScholarshipSession(id: string): Observable<any> {
    return this.http.get(this.url + 'scholarship-session/' + id);
  }

  updateScholarshipSession(
    data: ScholarshipSessionDto[]
  ): Observable<ScholarshipSessionDto[]> {
    return this.http.post<ScholarshipSessionDto[]>(
      this.url + 'scholarship-session/update',
      data
    );
  }

  deleteScholarshipSession(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('scholarship-session', ids.join(', '));
    return this.http.delete(this.url + 'scholarship-session', httpOptions);
  }
}
